<template>
  <ThemeProvider>
    <RouterView />
  </ThemeProvider>
</template>

<script setup lang="ts">
import { useToast } from 'vuestic-ui'
import ThemeProvider from './components/ThemeProvider.vue'
import toastService from './services/toastService'

// Initialize global toast service with Vuestic's toast
const { init: notify } = useToast()
toastService.init(notify)
</script>
<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
